interface ProfileIllustrationProps {
  companyImageUrl?: string;
}

export const ProfileIllustration = ({
  companyImageUrl,
}: ProfileIllustrationProps): React.ReactElement => {
  const hasCompanyImage = Boolean(companyImageUrl);

  return (
    <div className="relative h-[145px] w-[166px] shrink-0" aria-hidden>
      <svg
        width="166"
        height="145"
        viewBox="0 0 166 145"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-full w-full"
      >
        <g clipPath="url(#profile-card-clip)">
          <path
            d="M82.7445 144.212C128.225 144.212 165.095 111.929 165.095 72.1059C165.095 32.2829 128.225 0 82.7445 0C37.2636 0 0.394043 32.2829 0.394043 72.1059C0.394043 111.929 37.2636 144.212 82.7445 144.212Z"
            fill="#E6FAF7"
          />
          <path
            opacity="0.6"
            d="M135.543 28.4482C137.763 28.4482 139.562 26.6488 139.562 24.4292C139.562 22.2095 137.763 20.4102 135.543 20.4102C133.324 20.4102 131.524 22.2095 131.524 24.4292C131.524 26.6488 133.324 28.4482 135.543 28.4482Z"
            fill="#0AD1B7"
          />
          <path
            opacity="0.4"
            d="M21.671 94.7628C23.5207 94.7628 25.0201 93.2633 25.0201 91.4136C25.0201 89.5639 23.5207 88.0645 21.671 88.0645C19.8213 88.0645 18.3218 89.5639 18.3218 91.4136C18.3218 93.2633 19.8213 94.7628 21.671 94.7628Z"
            fill="#0AD1B7"
          />
          <path
            d="M55.087 108.674C84.6822 108.674 108.674 84.6822 108.674 55.0869C108.674 25.4917 84.6822 1.5 55.087 1.5C25.4917 1.5 1.5 25.4917 1.5 55.0869C1.5 84.6822 25.4917 108.674 55.087 108.674Z"
            transform="translate(26.4566 15.4248)"
            fill="white"
            stroke={!hasCompanyImage ? '#0AD1B7' : 'none'}
            strokeWidth="3"
          />
          {hasCompanyImage ? (
            <image
              href={companyImageUrl}
              x="26.4566"
              y="15.4248"
              width="111"
              height="111"
              preserveAspectRatio="xMidYMid slice"
              clipPath="url(#profile-card-image-clip)"
            />
          ) : (
            <g transform="translate(44.9566 31.9248)">
              <path
                d="M37 44.5C48.8741 44.5 58.5 34.8741 58.5 23C58.5 11.1259 48.8741 1.5 37 1.5C25.1259 1.5 15.5 11.1259 15.5 23C15.5 34.8741 25.1259 44.5 37 44.5Z"
                stroke="#0AD1B7"
                strokeWidth="3"
              />
              <path
                d="M1.5 76.5C5.05 55.1667 22.8 44.5 37 44.5C54.75 44.5 68.95 55.1667 72.5 76.5"
                stroke="#0AD1B7"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </g>
          )}
        </g>
        <defs>
          <clipPath id="profile-card-clip">
            <rect width="165.489" height="145" fill="white" />
          </clipPath>
          <clipPath id="profile-card-image-clip">
            <path
              d="M55.087 108.674C84.6822 108.674 108.674 84.6822 108.674 55.0869C108.674 25.4917 84.6822 1.5 55.087 1.5C25.4917 1.5 1.5 25.4917 1.5 55.0869C1.5 84.6822 25.4917 108.674 55.087 108.674Z"
              transform="translate(26.4566 15.4248)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
